<template>
    <div class="card card-custom gutter-b card-stretch ">
        <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">Tutoriales de apoyo</span>
                <span class="text-muted mt-3 font-weight-bold font-size-sm"></span>
            </h3>
        </div>
        <div class="card-body">

            <div class="card-columns">

                <div v-for="(item, index) in listTutorials" :key="index" class="card text-center card-hover">
                    <img class="card-img-top" :src="item.thumb" alt="Card image cap">
                    <div class="card-body">
                        <h5 class="card-title text-primary h3" v-text="item.name"></h5>
                        <p class="card-text" v-html="item.description"></p>
                        <a :href="item.url" target="_blank" class="btn btn-primary">ver archivo</a>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>
<script>

import code from "@/core/config/status.code";
import { TutoService, tutorialError } from '@/core/services/tutorials.service';
import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/store/htmlclass.module.js";
export default {
    name: 'tutoriales',
    data: ()=> ({
        listTutorials: []
    }),
    methods: {
        async getTutorials(){
            try {
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await TutoService.Tutorials();
                this.listTutorials = res.data;
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof tutorialError) {
                    this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
            
        }
    },
    created(){
        this.getTutorials();
    }
}
</script>